<script setup lang="ts">
import {ResponseFormat} from '@/client/mentor/MessagesClient'
import type {Suggestion} from '@/components/assistant/types'
import {Dropdown as VDropdown} from 'floating-vue'
import {computed, ref} from 'vue'

const emits = defineEmits<{
  select: [suggestion: Suggestion]
}>()

const props = defineProps<{
  label: string
  suggestions: Suggestion[] | Map<string, Suggestion[]>
  disabled?: boolean
}>()

const visibleMenu = ref(false)

const suggestionsMapping = computed(() => {
  if (Array.isArray(props.suggestions)) {
    return new Map([['', props.suggestions]])
  } else {
    return props.suggestions
  }
})

function onClickSuggestion(suggestion: Suggestion) {
  visibleMenu.value = false
  emits('select', suggestion)
}
</script>

<template>
  <VDropdown v-model:shown="visibleMenu" auto-hide placement="top-start" :show-triggers="['click']">
    <button type="button">
      <div class="h-6 px-2 bg-new-neutral-50 hover:bg-new-neutral-100 rounded-md flex flex-row items-center gap-2 truncate">
        <span>{{ label }}</span>
        <i v-if="visibleMenu" class="fa-solid fa-chevron-up text-xs"></i>
        <i v-else class="fa-solid fa-chevron-down text-xs"></i>
      </div>
    </button>

    <template #popper>
      <div class="bg-white flex flex-col gap-2 text-base max-h-96 overflow-y-auto">
        <div v-for="[groupLabel, suggestions] in suggestionsMapping.entries()" :key="groupLabel">
          <div v-if="groupLabel" class="font-semibold bg-new-neutral-100 px-2 py-0.5">{{ groupLabel }}</div>
          <div
            v-for="suggestion in suggestions"
            :key="suggestion.mainPart"
            class="hover:bg-new-secondary-100 hover:text-new-secondary-hover px-2 py-1"
          >
            <button type="button" @click="onClickSuggestion(suggestion)">
              <div class="flex flex-row gap-2 items-baseline text-left">
                <i v-if="suggestion.format === ResponseFormat.TABLE" class="fa-solid fa-table-cells text-xs"></i>
                <i v-else-if="suggestion.format === ResponseFormat.CHART" class="fa-solid fa-chart-column text-xs"></i>
                <span>{{ suggestion.mainPart }}</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </template>
  </VDropdown>
</template>
